import { render, staticRenderFns } from "./home-bottom.vue?vue&type=template&id=cd036692&scoped=true"
import script from "./home-bottom.vue?vue&type=script&lang=ts"
export * from "./home-bottom.vue?vue&type=script&lang=ts"
import style0 from "./home-bottom.vue?vue&type=style&index=0&id=cd036692&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd036692",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd036692')) {
      api.createRecord('cd036692', component.options)
    } else {
      api.reload('cd036692', component.options)
    }
    module.hot.accept("./home-bottom.vue?vue&type=template&id=cd036692&scoped=true", function () {
      api.rerender('cd036692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "home/home-bottom.vue"
export default component.exports